import { useDeferred } from '#src/clientState/hooks/useDeferred';
import {
  Sb_AddPromoCodeToUniversalShoppingBasketMutation,
  Sb_AddPromoCodeToUniversalShoppingBasketMutationVariables,
  Sb_RemovePromoCodeFromUniversalShoppingBasketMutation,
  Sb_RemovePromoCodeFromUniversalShoppingBasketMutationVariables,
} from '#src/generated/graphql';
import {
  UseMutationResult,
  useMutation,
} from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';

import {
  ADD_PROMOCODE_TO_SHOPPING_BASKET,
  REMOVE_PROMOCODE_FROM_SHOPPING_BASKET,
} from './operations/ShoppingBasketPromoCodeProvider.mutations';

export const useRemovePromoCodeFromShoppingBasket = () => {
  const { resolve, reset, reject, promise } = useDeferred();

  const removePromoCodeFromShoppingBasketResponse: UseMutationResult<
    Sb_RemovePromoCodeFromUniversalShoppingBasketMutation,
    Sb_RemovePromoCodeFromUniversalShoppingBasketMutationVariables
  > = useMutation(REMOVE_PROMOCODE_FROM_SHOPPING_BASKET, {
    onSuccess: ({ data }) => {
      resolve(data);
      reset();
    },
    onError: (error) => {
      reject(error);
      reset();
    },
  });

  const {
    data: result,
    errors,
    mutate,
    loading,
  } = removePromoCodeFromShoppingBasketResponse;

  useLogFrontendApiError(errors);

  const removePromoCodeFromShoppingBasket = ({ shoppingBasketId, id }) => {
    mutate({
      request: {
        shoppingBasketId,
        id,
      },
    });
    return promise;
  };

  return {
    result,
    loading,
    removePromoCodeFromShoppingBasket,
    errors,
  };
};

export const useAddPromoCodeToShoppingBasket = () => {
  const { resolve, reset, reject, promise } = useDeferred();

  const addPromoCodeToShoppingBasketResponse: UseMutationResult<
    Sb_AddPromoCodeToUniversalShoppingBasketMutation,
    Sb_AddPromoCodeToUniversalShoppingBasketMutationVariables
  > = useMutation(ADD_PROMOCODE_TO_SHOPPING_BASKET, {
    onSuccess: ({ data }) => {
      resolve(data);
      reset();
    },
    onError: (error) => {
      reject(error);
      reset();
    },
  });

  const {
    data: result,
    errors,
    mutate,
    loading,
  } = addPromoCodeToShoppingBasketResponse;

  useLogFrontendApiError(errors);

  const addPromoCodeToShoppingBasket = ({ shoppingBasketId, code }) => {
    mutate({
      request: {
        shoppingBasketId,
        code,
      },
    });
    return promise;
  };

  return {
    result,
    loading,
    addPromoCodeToShoppingBasket,
    errors,
  };
};
